<nav class="navbar navbar-expand-md bg-dark navbar-dark fixed-top">
    <div class="container">           
        <div class="navbar-brand navitem nav-link active">
            <app-logo-contact></app-logo-contact>
        </div> 

    </div>
</nav>